import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../layouts";
import {
    Acccordion,
    Buttton,
    Header,
    Inputs,
    Sides,
} from "../../../components";

import { Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useAlert, useModal, useSnackBar, useToast } from "../../../contexts";
import { useTranslation } from "react-i18next";
import { actionDoctor } from "../../../redux/actions";
import { PiInfo, PiTrash } from "react-icons/pi";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { TbInfoTriangleFilled } from "react-icons/tb";

const Faq = ({ loginData }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { showAlert } = useAlert();
    const { showToast } = useToast();
    const { showSnackBar } = useSnackBar();
    const { showModal, hideModal } = useModal();

    const [isVisible, setIsVisible] = useState(false);
    const [credentials, setCredentials] = useState({
        question: "",
        answer: "",
        doctorFAQGuid: null,
        doctorGuid: loginData.userGuid,
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let newErrors = {};
        if (!credentials.question.trim()) {
            newErrors.question = "Question is required *";
        }
        if (!credentials.answer.trim()) {
            newErrors.answer = "Answer is required *";
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        dispatch(
            actionDoctor.postSaveFaq(credentials, (error, response) => {
                if (error) {
                    if (error.data) {
                        if (error.data.statusCode === 400) {
                            if (error.data.error && error.data.error.ValidationErrors) {
                                error.data.error.ValidationErrors.forEach((validationError) => {
                                    console.error(
                                        `${t("Field")}: ${validationError.Field} - ${t(
                                            "Message"
                                        )}: ${validationError.Message}`
                                    );

                                    showAlert(
                                        "danger",
                                        validationError.Message,
                                        `${t("Error")} : ${validationError.Field}`
                                    );
                                });
                            } else {
                                showAlert(
                                    "danger",
                                    `${t("Invalid_credentials")}`,
                                    `${t("Error")} !`
                                );
                            }
                        } else {
                            showAlert("danger", `${t("unexpected_error")}``${t("Error")} !`);
                        }
                    }
                } else if (response) {
                    if (response.status === 200) {
                        dispatch(actionDoctor.getFAQ(loginData.userGuid, ""));
                        showToast(
                            t("success"),
                            t("doctor.faq.update_success"),
                            5000,
                            true,
                            "top-center toast-success"
                        );
                        setIsVisible(!isVisible);
                        setCredentials({
                            ...credentials,
                            question: "",
                            answer: "",
                        });
                    }
                }
            })
        );
    };

    useEffect(() => {
        dispatch(actionDoctor.getFAQ(loginData.userGuid, ""));
    }, [dispatch, loginData]);

    const getFaqData = useSelector((state) => state.doctor.getFaqData?.data);

    const handleEdit = (faq) => {
        setIsVisible(!isVisible);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setCredentials({
            ...credentials,
            question: faq.question || "",
            answer: faq.answer || "",
            doctorFAQGuid: faq.doctorFAQGuid || null,
        });
    };
    const handleDelete = (faq) => {
        showModal({
            title: <h2 className="exado-title-nine">{t("doctor.faq.delete_custom_time")}</h2>,
            bodyContent: <TbInfoTriangleFilled className="info-triangle-icon" />,
            bodyContent1: (
                <p className="exado-title-six">
                    {" "}
                    {t("doctor.faq.delete_confirmation")}
                </p>
            ),
            // autoClose: 5000,
            footer: (
                <>
                    <Buttton.Buttton
                        children={t("CANCEL")}
                        className="btn-border-Aqua_Teal"
                        onClick={hideModal}
                    />
                    <Buttton.Buttton
                        children={t("delete")}
                        className="btn-solid-Carmine_red"
                        onClick={() => {
                            hideModal();
                            dispatch(
                                actionDoctor.deleteFaq(
                                    faq?.doctorFAQGuid,
                                    (error, response) => {
                                        if (error) {
                                            if (error.data) {
                                                if (error.data.statusCode === 400) {
                                                    if (
                                                        error.data.error &&
                                                        error.data.error.ValidationErrors
                                                    ) {
                                                        error.data.error.ValidationErrors.forEach(
                                                            (validationError) => {
                                                                console.error(
                                                                    `${t("Field")}: ${validationError.Field
                                                                    } - ${t("Message")}: ${validationError.Message
                                                                    }`
                                                                );

                                                                showAlert(
                                                                    "danger",
                                                                    validationError.Message,
                                                                    `${t("Error")} : ${validationError.Field}`
                                                                );
                                                            }
                                                        );
                                                    } else {
                                                        showAlert(
                                                            "danger",
                                                            `${t("Invalid_credentials")}`,
                                                            `${t("Error")} !`
                                                        );
                                                    }
                                                } else {
                                                    showAlert(
                                                        "danger",
                                                        `${t("unexpected_error")}``${t("Error")} !`
                                                    );
                                                }
                                            }
                                        } else if (response) {
                                            if (response.status === 200) {
                                                dispatch(actionDoctor.getFAQ(loginData.userGuid, ""));
                                                showSnackBar(
                                                    t("doctor.faq.update_success_short"),
                                                    "snackbar-success"
                                                );
                                            }
                                        }
                                    }
                                )
                            );
                        }}
                    />
                </>
            ),
            className: "del-modal",
        });
    };

    const transformedData = getFaqData?.result.map((faq) => ({
        title: faq?.question,
        content: (
            <>
                <div>
                    <div>{faq?.answer}</div>
                    <div className="ans-edit-del-blk">
                        <span>
                            <FiEdit onClick={() => handleEdit(faq)} className="editIcon" />
                        </span>
                        <span>
                            <PiTrash
                                onClick={() => handleDelete(faq)}
                                className="delIcon noVerify"
                            />
                        </span>
                    </div>
                </div>
            </>
        ),
    }));
    const buttons = (
        <>
            {!isVisible && (
                <Buttton.Buttton
                    children={t("add_question")}
                    className="btn-solid-Aqua_Teal"
                    onClick={() => setIsVisible(!isVisible)}
                />
            )}
        </>
    );
    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage
                        pageHeading={t("doctor.faq.title")}
                        buttons={buttons}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <h3 className="exado-title-three">
                        {t("doctor.faq.personalized_qna")}
                    </h3>
                </Col>
            </Row>
            {isVisible && (
                <Row className="exado-row1">
                    <Col>
                        <section className="faq-form-section">
                            <Form onSubmit={handleSubmit}>
                                <div className="inputBlk">
                                    <h5 className="exado-title-six">
                                        {t("doctor.faq.create_personalized_qna")}
                                    </h5>
                                    <Inputs.FormInputs
                                        label={
                                            errors.question ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.question}
                                                </span>
                                            ) : (
                                                t("doctor.faq.write_faq_question")
                                            )
                                        }
                                        value={credentials.question}
                                        name="question"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.question ? "form-group-error" : ""
                                            }`}
                                    />
                                    <Inputs.FormInputs
                                        type="textarea"
                                        label={
                                            errors.answer ? (
                                                <span className="error-message">{errors.answer}</span>
                                            ) : (
                                                t("doctor.faq.write_faq_answer")
                                            )
                                        }
                                        name="answer"
                                        value={credentials.answer}
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.answer ? "form-group-error" : ""
                                            }`}
                                    />
                                </div>
                                <div className="btn-blk">
                                    <Buttton.Buttton
                                        children={t("CANCEL")}
                                        className="btn-border-Aqua_Teal"
                                        onClick={() => setIsVisible(!isVisible)}
                                    />
                                    <Buttton.Buttton
                                        type="submit"
                                        children={t("save")}
                                        className="btn-solid-Aqua_Teal"
                                    />
                                </div>
                            </Form>
                        </section>
                    </Col>
                </Row>
            )}
            <Row className="exado-row1">
                <Col>
                    <section className="faq-acc-section">
                        <h5 className="exado-title-six">
                            <PiInfo className="info-icn" />
                            {t("doctor.faq.faq_list_intro")}
                            {" "}
                            <span className="faq-acc-section-heading-span">
                                {t("doctor.faq.faq_list_action")}
                            </span>
                        </h5>

                        <h3 className="exado-title-three">{t("doctor.faq.faq_list_title")}</h3>

                        <Acccordion.Acccordion
                            items={transformedData}
                            defaultActiveKey={["0"]}
                            alwaysOpen={false}
                            className="acccordian acccordian2"
                            Open={<FaCaretUp className="acc-icn" />}
                            Close={<FaCaretDown className="acc-icn" />}
                        />
                    </section>
                </Col>
            </Row>
            {/* <pre style={{ fontSize: "16px" }}>{JSON.stringify(getFaqData, null, 2)}</pre> */}
        </Container>
    );
    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default Faq;
